<template>
  <div class="row">
    <div v-loading="loadingApplication" element-loading-spinner="qc-spinner" class="col-md-12 card">
      <div class="card-header">
        <h4 class="card-title">Application Details</h4>
      </div>
      <div class="card-content row ">
        <div class="form-horizontal">
          <dynamic-input name="organisation" label="Organisation" placeholder="Organisation" description="This is the organisation your application will be submitted to." v-model="owner" :readOnly="true" />

          <div v-if="application">
            <dynamic-input 
              v-for="field in application.fields"
              :key="field.key"
              :name="field.key"
              :label="field.name" 
              :description="field.description"
              :placeholder="field.name" 
              :mask="field.mask"
              v-model="field.value" 
              :validations="$service.buildValidations(field)"
              :type="field.type"
              :refData="(field.refData == 'TRUE' || field.refData == 'ONLY')"
              :refDataValues="field.values ? field.values.map(value => {return {name: value}}) : null"
              :refDataRestricted="field.refData == 'ONLY'"
              :readOnly="false" />

            <div v-if="!inflow && application.fields && application.fields.length > 0" class="col-sm-12">
              <button @click.prevent="updateApplication" type="button" class="btn btn-info btn-fill btn-wd pull-right"><i class="fa fa-save"/> Save</button>
            </div>
          </div>

        </div>
        
      </div>
    </div>

    <div v-if="application && application.documents && application.documents.length > 0" v-loading="loadingApplication" element-loading-spinner="qc-spinner" class="col-md-12 card">
      <div class="card-header">
        <h4 class="card-title">Documents</h4>
        <div class="category">Documents and evidence requested by the organisation, in addition to any documents you provide for qualification verifications. You can also use "Add another document" to add any further documentation you feel might be useful. <b>(Must be pdf file type)</b></div>
      </div>
      <div class="card-content row">
        <div v-if="application">

          <document-card 
            v-for="document, index in application.documents" 
            :key="index" 
            :document="document"
            :deleteData="documentDeleteData" 
            @deleted="removeDocument(index)"
            :canAdd="true"
            :canDelete="true" />

          <div @click.prevent="addDocument">
            <document-card :document="fakeDocument" />
          </div>
        </div>
      </div>
    </div>
        
    <div v-if="!inflow" v-loading="loadingApplication" element-loading-spinner="qc-spinner" class="col-md-12 card">
      <div class="card-header">
        <h4 class="card-title">Verifications</h4>
        <div class="category">Your verified qualifications included in the application. Add as many as you would like the organisation to review.</div>
      </div>
      <div class="card-content row ">
        <div class="form-group">          
          <verification-history-table
            :items="application ? application.verifications : []"
            :showPagination="false" />

          <div class="col-sm-12">
            <button @click.prevent="selectVerifications" type="button" class="btn btn-info btn-fill btn-wd pull-right"><i class="fa fa-plus"/> Select Verifications</button>
          </div>
        </div>    
      </div>
    </div>

  </div>
</template>

<script>
  import VerificationHistoryTable from 'src/views/Verifications/components/VerificationHistoryTable'
  import ModalVerificationTransfer from 'src/components/ModalPlugin/ModalVerificationTransfer'
  import ModalUploader from 'src/components/ModalPlugin/ModalUploader'
  import DocumentInput from 'src/views/Verifications/components/DocumentInput'
  import DocumentCard from 'src/views/Verifications/components/DocumentCard'

  import DynamicInput from 'src/views/Verifications/components/DynamicInput'

  import { Loading } from 'element-ui'

  import moment from 'moment'
  
  export default {
    name: "application-view",
    components: {
      DynamicInput,
      DocumentInput,
      DocumentCard,
      'verification-history-table': VerificationHistoryTable
    },
	  inject: ['$validator'], // inject parent validator
    props: {
      id: String,
      initApplication: Object,
      additionalDocsAllowed: { type: Number, default: 5},
      inflow: {type: Boolean, default: false}
    },
    data () {
      return {
        loadingApplication: false,
        application: null
      }
    },
    mounted: function () {
      this.loadingApplication = true
      if(this.initApplication) {
        const appTemp = this.initApplication
        appTemp.documents = appTemp.documents.map(doc => ({ ...doc }))
        this.application = appTemp
        this.loadingApplication = false
      } else {
        this.$api.getApplication(this.id)
          .then(response => {
            this.$service.buildApplicationDocuments(response.data)
            response.data.documents = response.data.documents.map(doc => ({ ...doc }))
            this.application = response.data
            this.loadingApplication = false
          })
          .catch(error => {
            console.log(error)
            this.loadingApplication = false
          })
      }
    },
    computed: {
      owner() {
        if(this.application) {
          return this.application.owner.name
        } else {
          return "Loading ..."
        }
      },
      additionalDocsLeft() {
        var docsLeft = this.additionalDocsAllowed
        if(this.application.documents && this.application.documents.length > 0) {
          this.application.documents.forEach(doc => {
            if(!doc.required) {
              docsLeft--
            }
          })
        }
        return docsLeft
      },
      fakeDocument() {
        return {
          "fake": true,
          "name": "Add another document",
          "description": "Optionally attach up to " + this.additionalDocsLeft + " additional documents as supporting evidence."
        }
      }
    },
    methods: {
      formatDate(date) {
        return moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD')
      },
      updateApplication() {
        this.loadingApplication = true
        this.$api.updateApplication(this.application.id, {fields: this.application.fields, documents: this.application.documents})
          .then(response => {
            this.$snotify.success("Application details saved.", "Success")
            this.application = response.data
            this.loadingApplication = false
          })
          .catch(error => {
            console.log(error)
            this.loadingApplication = false
          })
      },
      selectVerifications() {
        this.$modal.show(ModalVerificationTransfer,
          {
            initSelected: this.application.verifications,
            action: (selectedVerifications) => {
              this.loadingApplication = true
              this.$modal.close()
              this.$api.updateApplicationVerifications(this.application.id, selectedVerifications)
                .then(response => {
              this.$snotify.success("Verification selection saved.", "Success")
                  this.application = response.data
                  this.loadingApplication = false
                })
                .catch(error => {
                  console.log(error)
                  this.loadingApplication = false
                })
            }
          })
      },
      documentDeleteData (document) {
        return new Promise((resolve, reject) => {
          resolve()
        })
      },
      addDocument() {
        this.$modal.show(ModalUploader,
              {
                title: "Add Document",
                message: "Please enter a short label describing your document.",
                closeText: "Cancel",
                action: (value, filename, base64Data) => 
                  {
                    this.application.documents.push({
                      id: null,
                      filename: filename,
                      data: base64Data,
                      required: false,
                      name: value,
                      applicationId: this.application.id
                    })
                    this.$modal.close()
                  }
              })

      },
      removeDocument(index) {
        this.application.documents.splice(index, 1)
      }
    }
  }
</script>

<style>

</style>